// eslint-disable-next-line no-restricted-imports
import { LegalClientLegalHeadFragment } from 'api/generated/graphql';
import { parseOnboardingProcessEntity } from 'api/requests/onboarding/helpers';
import { LegalClientLegalHeadEntity } from 'api/types/entity';
import { lodash } from 'helpers';

import { parseHeadPositionEntity } from '../../helpers/parseHeadPositionEntity';
import { parseLegalClientBodyEntity } from '../../helpers/parseLegalClientBodyEntity';
import { parseLegalClientLegalHeadStateRegistration } from '../../helpers/parseLegalClientLegalHeadStateRegistration';
import { parseLegalClientTaxResidency } from '../../helpers/parseLegalClientTaxResidency';
import { parseOrganizationalAndLegalFormEntity } from '../../helpers/parseOrganizationalAndLegalFormEntity';

export const parseLegalClientLegalHeadEntity = (
  data: LegalClientLegalHeadFragment
): LegalClientLegalHeadEntity => ({
  id: data.id,
  createdAt: new Date(data.createdAt),
  fullName: data.fullName ?? undefined,
  shortName: data.shortName ?? undefined,

  isFirstHead: data.isFirstHead ?? undefined,
  legalClientBodies: data.legalClientBodies
    ? parseLegalClientBodyEntity(lodash.compact(data.legalClientBodies))
    : undefined,

  legalAddress: data.legalAddress,
  actualAddress: data.actualAddress,

  taxResidences: data.taxResidences
    ? lodash.compact(data.taxResidences).map(parseLegalClientTaxResidency)
    : undefined,
  stateRegistration: parseLegalClientLegalHeadStateRegistration(data),
  firstHeads: lodash.compact(data.firstHeads).map((firstHead) => ({
    id: firstHead.id,
    firstName: firstHead.firstName,
    lastName: firstHead.lastName,
    middleName: firstHead.middleName || undefined,
    onboarding: {
      isCompletedByRepresentative:
        firstHead.onboarding?.isCompletedByRepresentative ?? false,
    },
  })),

  onboarding: data.onboarding
    ? {
        process: parseOnboardingProcessEntity(data.onboarding?.process),
      }
    : undefined,

  position: data.positionInCompany
    ? parseHeadPositionEntity(data.positionInCompany)
    : undefined,

  organizationalAndLegalForm: parseOrganizationalAndLegalFormEntity(
    data.organizationalAndLegalForm ?? undefined
  ),
  hasLegalClientBody: data.hasLegalClientBody ?? undefined,
});
